export const DESCRIPTION = 'Element';
export const FROM = 'ExprLow';
export const TO = 'ExprHigh';

export const DESC_MAP = new Map([
    ['COMPANYCODE', 'Company Code'],
    ['BLOCKINGREASON', 'Blocking Reason'],
    ['MATERIALGROUP', 'Material Group'],
    ['MATERIALTYPE', 'Material Type'],
    ['PLANT', 'Plant'],
    ['PURCHASINGGROUP', 'Purchasing Group'],
    ['STORAGELOCATION', 'Storage Location'],
]);

export const TEMPLATE = Array.from(DESC_MAP.keys()).map((element) => {
    return {
        Element: element,
        ExprLow: '',
        ExprHigh: '',
        RespStartDate: '',
        RespEndDate: '',
    };
});

export const isElementInRule = (row, rule) => {
    if (rule === '91200026') {
        return ['MATERIALGROUP', 'MATERIALTYPE', 'PLANT', 'STORAGELOCATION'].includes(row[DESCRIPTION]);
    } else {
        return !['MATERIALTYPE', 'STORAGELOCATION'].includes(row[DESCRIPTION]);
    }
};
